import { render } from "./NotFound.vue?vue&type=template&id=56960ce6&scoped=true&lang=pug"
import script from "./NotFound.vue?vue&type=script&lang=ts"
export * from "./NotFound.vue?vue&type=script&lang=ts"

import "./NotFound.vue?vue&type=style&index=0&id=56960ce6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-56960ce6"

export default script